import { getLink } from "../../../utils/utils"
import img1 from '../../images/pasko.jpg';

const content = {
	esp: (
		`
			<div style="text-align: justify;">
				
				<div class="text-center mb-3">
					<img src=${img1} />
				</div>
				<p class="mb-3">
					La ortodoksa Pasko okazos ĉi-jare la 5-an de majo. 
					La daton oni kalkulas jene: ekde la printempa ekvinokso oni indikas la unuan plenlunon, 
					kaj en la unua dimanĉo post tiu plenluno oni festas la Paskon. 
					La datoj de la ortodoksa kaj katolika Paskoj diversas, 
					ĉar ortodoksoj kalkulas ekde la dato de 21-a de marto laŭ Julia kalendaro, kio respondas al la 3-a de aprilo laŭ la Gregoria. 
					Niaj religiaj kalendaroj estas diversaj. 
				</p>
				
				<p class="mb-3">
					Antaŭ Pasko ni observas 50-tagan Karesmon, aŭ Grandan Faston. 
					Tiam ne indas manĝi viandaĵojn, laktaĵojn kaj ovaĵojn. 
					La lasta semajno de la ortodoksa Karesmo nomiĝas Pasiona Semajno. 
					Je mia miro, en Esperanta Vikipedio mi trovis nenion pri ortodoksaj Paskaj kutimoj. 
					Ŝajnas, ke Okcidenta Eŭropo vere estas rasisma – sed ne al Afriko, sed al siaj orientaj kuneŭropanoj, 
					kiujn oni simple ne rimarkas kaj ne atentas. 
				</p>
				
				<p class="mb-3">
					Antaŭ Pasko ni ordigas kaj purigas la hejmon, lavas fenestrojn kaj tolaĵojn; 
					en vilaĝoj freŝe kalkumas la domojn ekstere kaj interne. 
					Preparas por la festa manĝo viandaĵojn, farbas malmole kuiritajn ovojn, bakas specialan Paskan kukon. 
					Antaŭvespere de la festo oni vizitas preĝejon por partopreni Tutnoktan diservon, 
					dum kiu pastroj ankaŭ benas la alportitajn de la kredantoj festajn manĝaĵojn kaj vinon. 
				</p>
				
				<p class="mb-3">
					Tage dimanĉe oni vizitas gratule parencojn, amikojn, suferantojn, alportas al ili paskajn kukojn kaj ovojn. 
					Manĝas kune la festan tagmanĝon. 
					Dum la unua semajno de la Pasko oni salutas unu la alian ne per: “Saluton!”,”Bonan tagon!” ktp, sed dirante: “Kristo resurektis!”. 
					La respondo estas “Vere resurektis!”, kaj homoj interkisiĝas, unu- aŭ trifoje. 
					Multaj homoj faras tion eĉ nun.
				</p>
			</div>
		`
	)
}

const itemName = {
	esp: 'Iom pri Ortodoksa Pasko'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}
export default item;